import React, { useState, useEffect } from "react";

const AnsibleDetail = ({ task, onClose, onRun, onDelete, onEdit }) => {
  const [editMode, setEditMode] = useState(false);
  const [form, setForm] = useState({
    name: "",
    playbook_content: "",
    inventory_content: "",
  });

  // task가 변경될 때 form 초기화
  useEffect(() => {
    if (task) {
      setForm({
        name: task.name || "",
        playbook_content: task.playbook_content || "",
        inventory_content: task.inventory_content || "",
      });
    }
  }, [task]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (!form.name.trim()) return alert("이름을 입력해주세요.");
    onEdit(task.id, form);  // 부모에게 수정 요청
    setEditMode(false);
  };

  if (!task) return null;

  return (
    <div className="fixed top-0 right-0 w-full sm:w-1/2 md:w-1/3 h-full bg-white shadow-lg p-6 overflow-y-auto z-50">
      <button onClick={onClose} className="text-gray-600 hover:text-black float-right">
        ❌
      </button>

      <h2 className="text-xl font-bold text-blue-600 mb-4">
        {editMode ? "작업 수정" : task.name}
      </h2>

      {/* 이름 */}
      <div className="mb-4">
        <label className="font-semibold">이름</label>
        {editMode ? (
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full border px-2 py-1 rounded mt-1"
          />
        ) : (
          <div>{task.name}</div>
        )}
      </div>

      {/* Playbook */}
      <div className="mb-4">
        <label className="font-semibold">Playbook</label>
        {editMode ? (
          <textarea
            name="playbook_content"
            value={form.playbook_content}
            onChange={handleChange}
            rows={6}
            className="w-full border px-2 py-1 rounded mt-1"
          />
        ) : (
          <pre className="bg-gray-100 p-2 rounded whitespace-pre-wrap">
            {task.playbook_content}
          </pre>
        )}
      </div>

      {/* Inventory */}
      <div className="mb-4">
        <label className="font-semibold">Inventory</label>
        {editMode ? (
          <textarea
            name="inventory_content"
            value={form.inventory_content}
            onChange={handleChange}
            rows={4}
            className="w-full border px-2 py-1 rounded mt-1"
          />
        ) : (
          <pre className="bg-gray-100 p-2 rounded whitespace-pre-wrap">
            {task.inventory_content}
          </pre>
        )}
      </div>

      {/* 버튼 영역 */}
      <div className="flex justify-end space-x-2">
        {editMode ? (
          <>
            <button onClick={handleSave} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
              💾 저장
            </button>
            <button onClick={() => setEditMode(false)} className="bg-gray-400 text-white px-4 py-2 rounded">
              취소
            </button>
          </>
        ) : (
          <>
            <button onClick={() => setEditMode(true)} className="bg-yellow-400 text-white px-4 py-2 rounded hover:bg-yellow-500">
              ✏ 수정
            </button>
            <button onClick={() => onRun(task.id)} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
              ▶ 실행
            </button>
            <button onClick={() => onDelete(task.id)} className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
              🗑 삭제
            </button>
          </>
        )}
      </div>
      <div className="mb-4">
        {task.output && (
          <div className="mb-4">
            <strong>실행 결과:</strong>
            <pre className="bg-black text-green-400 p-3 rounded mt-1 text-sm whitespace-pre-wrap overflow-auto max-h-96">
              {task.output}
            </pre>
          </div>
        )}

      </div>
    </div>
  );
};

export default AnsibleDetail;
